import React, { useCallback, useEffect, useState } from 'react';
import { not, pick, prop } from 'ramda';
import { useDeviceSelector } from 'js/store/hooks';
import { usePortletConfig, usePortletSelector } from 'js/components/system/Portlet';
import Reset from 'js/components/main/Games/Filters/Reset';
import Tags from 'js/components/main/Games/Filters/Tags';

import Categories from './Categories';

import style from './index.scss';

export const FiltersRow = ({
    appliedFiltersCount,
    className = ''
}) => {
    const { showGameCategoriesFilter } = usePortletConfig();

    return (
        <>
            <div className={`${style.container} ${className}`}>
                <div className={style.content}>
                    {showGameCategoriesFilter && <Categories />}
                    {appliedFiltersCount > 0 && <Reset />}
                </div>
            </div>
            {appliedFiltersCount > 0 && <Tags />}
        </>
    );
};

export const FiltersGrid = ({
    appliedFiltersCount,
    className = ''
}) => {

    return (
        <>
            <div className={`${style.container} ${className}`}>
                {appliedFiltersCount > 0 && <Reset />}
            </div>
        </>
    );
};

export default ({ className }) => {
    const [isOpen, setIsOpen] = useState(false);
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const {
        isSearchActive: isCollapse
    } = usePortletSelector(pick(['filters', 'isSearchActive']));

    useEffect(() => {
        if (isCollapse && isOpen) {
            setIsOpen(false);
        }
    }, [isCollapse, isOpen]);

    const toggleFilters = useCallback(() => setIsOpen(not), []);
    const filterProps = {
        className,
        isOpen,
        toggleFilters
    };

    return isDesktop
        ? <FiltersRow {...filterProps} />
        : <FiltersGrid {...filterProps} />;
};
